import React, { useState, useEffect } from "react";

function OmnifactoryBanner() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Mobile layout - image on top, text below
    if (isMobile) {
        return (
            <div className="relative w-full bg-black pb-8">
                {/* Image at the top */}
                <div className="relative w-full">
                    {/* Background image */}
                    <img
                        src="/assets/omnifactory-bg.jpg"
                        alt="OmniFactory Background"
                        className="w-full object-cover"
                    />
                    
                    {/* Gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/80"></div>
                </div>
                
                {/* Text content below the image */}
                <div className="w-full bg-black px-8 py-12">
                    <div className="w-full flex flex-col items-start justify-center text-white space-y-4 px-4">
                        <p className="font-inter-light text-xl text-center leading-8">
                            Com a abordagem{" "}
                            <span className="font-inter-bold">OmniFactory™</span>, unimos
                            nossa expertise em SAP, TOTVS e Senior a uma fábrica de
                            desenvolvimento inteligente, que atua com processos
                            maduros, versionamento, integração contínua e squads sob
                            demanda.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    // Desktop layout - original side-by-side approach
    return (
        <div className="relative w-full bg-black overflow-hidden">
            <div className="container mx-auto px-4 py-24 flex flex-col lg:flex-row items-center">
                {/* Text content - 2/3 of the screen */}
                <div className="w-full lg:w-2/3 z-10 text-white px-4 lg:px-36">
                    <p className="font-inter-light md:text-2xl mb-6">
                        Com a abordagem{" "}
                        <span className="font-inter-bold">OmniFactory™</span>, unimos
                        nossa expertise em SAP, TOTVS e Senior a uma fábrica de
                        desenvolvimento inteligente, que atua com processos
                        maduros, versionamento, integração contínua e squads sob
                        demanda.
                    </p>
                </div>

                {/* Background image - positioned to the right */}
                <div className="absolute top-0 right-0 h-full w-full lg:w-1/2">
                    <div className="relative h-full w-full">
                        <img
                            src="/assets/omnifactory-bg.jpg"
                            alt="OmniFactory Background"
                            className="h-full w-full object-cover object-center"
                        />
                        {/* Dark gradient overlay - darker on the left */}
                        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/10 to-transparent"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OmnifactoryBanner;
